import { jsx as _jsx } from "react/jsx-runtime";
import useTriggerAnalyticsEvent from '../../../../hooks/use-trigger-analytics-event';
import GenericError from '../../../common/generic-error';
var SelectPayGenericError = function () {
    useTriggerAnalyticsEvent('selectPay.serverError');
    return _jsx(GenericError, {});
};
export default SelectPayGenericError;
//# sourceMappingURL=index.js.map